import { Component } from 'san';
import { PAGE_SIZE } from 'src/consts';
const PAGE_LIMIT = 5; // 最多显示的页码数量

export default class Pagination extends Component {
    constructor(options: any) {
        super(options);
    }

    static computed = {
        pages() {
            const pages = [];
            const current = this.data.get('page');
            const total = this.data.get('total');
            const pageLimit = this.data.get('pageLimit') || PAGE_LIMIT; // 最多显示的页码标签数
            const totalPage = Math.ceil(total / this.data.get('limit')) || 1; // 总页数
            const middle = Math.ceil(pageLimit / 2);
            if (totalPage < pageLimit) {
                let i = 0;
                while (++i < current) {
                    pages.push(i);
                }
                pages.push(current);
                i = current;
                while (++i <= totalPage) {
                    pages.push(i);
                }
            } else if (current < middle) {
                let i = 0;
                while (++i < current) {
                    pages.push(i);
                }
                pages.push(current);
                i = 0;
                while (++i <= pageLimit - current) {
                    pages.push(current + i);
                }
            } else if (current > totalPage - middle) {
                let i = totalPage - pageLimit;
                while (++i < current) {
                    pages.push(i);
                }
                pages.push(current);
                i = current;
                while (++i <= totalPage) {
                    pages.push(i);
                }
            } else {
                let i = middle;
                while (--i > 0) {
                    pages.push(current - i);
                }
                pages.push(current);
                i = 0;
                while (i++ < pageLimit - middle) {
                    pages.push(current + i);
                }
            }
            return pages;
        },
        lastPage() {
            const total = this.data.get('total');
            return Math.ceil(total / this.data.get('limit')) || 1;
        },
    };

    inited() {
        this.watch('limit', () => {
            this.goToPage(1);
        });
    }

    initData(): {
        limitsArray: { value: number; label: string }[];
        page: number;
        limit: number;
        total: number;
        enableChangeLimit: boolean;
    } {
        return {
            limitsArray: [
                { value: 10, label: '每页 10 条' },
                { value: 15, label: '每页 15 条' },
                { value: 20, label: '每页 20 条' },
                { value: 30, label: '每页 30 条' },
                { value: 40, label: '每页 40 条' },
                { value: 50, label: '每页 50 条' },
                { value: 100, label: '每页 100 条' },
            ],
            page: 1, // (input)页码
            limit: PAGE_SIZE, // (input)分页大小
            total: 0, // (input)总条数
            enableChangeLimit: false, // (input)可变更分页大小
        };
    }

    goToPage(page: number) {
        const lastPage = this.data.get('lastPage');
        if (page < 1 || page > lastPage) {
            return;
        }
        this.fire('page-change', { page, limit: this.data.get('limit') });
    }

    goToFirstPage() {
        if (this.data.get('page') > 1) {
            this.goToPage(1);
        }
    }
  
    goToLastPage() {
        const lastPage = this.data.get('lastPage');
        if (this.data.get('page') < lastPage) {
            this.goToPage(lastPage);
        }
    }
}
